/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Delivery_Board_Update_ErrorInputs */

const en_delivery_board_update_error = /** @type {(inputs: Delivery_Board_Update_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to update order status. Please try again.`)
};

const es_delivery_board_update_error = /** @type {(inputs: Delivery_Board_Update_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al actualizar el estado del pedido.`)
};

const fr_delivery_board_update_error = /** @type {(inputs: Delivery_Board_Update_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Échec de la mise à jour du statut de la commande. Veuillez réessayer.`)
};

const de_delivery_board_update_error = /** @type {(inputs: Delivery_Board_Update_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fehler beim Aktualisieren des Bestellstatus.`)
};

const id_delivery_board_update_error = /** @type {(inputs: Delivery_Board_Update_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gagal memperbarui status pesanan. Silakan coba lagi.`)
};

/** @type {(inputs: Delivery_Board_Update_ErrorInputs) => LocalizedString} */
const ja_delivery_board_update_error = en_delivery_board_update_error;

/** @type {(inputs: Delivery_Board_Update_ErrorInputs) => LocalizedString} */
const zh_delivery_board_update_error = en_delivery_board_update_error;

/** @type {(inputs: Delivery_Board_Update_ErrorInputs) => LocalizedString} */
const ar_delivery_board_update_error = en_delivery_board_update_error;

/** @type {(inputs: Delivery_Board_Update_ErrorInputs) => LocalizedString} */
const it_delivery_board_update_error = en_delivery_board_update_error;

/** @type {(inputs: Delivery_Board_Update_ErrorInputs) => LocalizedString} */
const ru_delivery_board_update_error = en_delivery_board_update_error;

/** @type {(inputs: Delivery_Board_Update_ErrorInputs) => LocalizedString} */
const pt_delivery_board_update_error = en_delivery_board_update_error;

/** @type {(inputs: Delivery_Board_Update_ErrorInputs) => LocalizedString} */
const ko_delivery_board_update_error = en_delivery_board_update_error;

/**
* | output |
* | --- |
* | "Failed to update order status. Please try again." |
*
* @param {Delivery_Board_Update_ErrorInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const delivery_board_update_error = /** @type {((inputs?: Delivery_Board_Update_ErrorInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Delivery_Board_Update_ErrorInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_delivery_board_update_error(inputs)
	if (locale === "es") return es_delivery_board_update_error(inputs)
	if (locale === "fr") return fr_delivery_board_update_error(inputs)
	if (locale === "de") return de_delivery_board_update_error(inputs)
	if (locale === "ja") return ja_delivery_board_update_error(inputs)
	if (locale === "zh") return zh_delivery_board_update_error(inputs)
	if (locale === "ar") return ar_delivery_board_update_error(inputs)
	if (locale === "id") return id_delivery_board_update_error(inputs)
	if (locale === "it") return it_delivery_board_update_error(inputs)
	if (locale === "ru") return ru_delivery_board_update_error(inputs)
	if (locale === "pt") return pt_delivery_board_update_error(inputs)
	return ko_delivery_board_update_error(inputs)
});